import React from "react";
import classNames from "classnames";
import { useDrawingContext } from "../../Contexts/DrawingContext";
import { DrawType } from "../../Map/enums";

export interface IDrawingButton {
    iconClass: string;
    type: DrawType;
}

export const DrawingButton = ({ iconClass, type }: IDrawingButton): JSX.Element => {
    const { drawType, onDrawStart } = useDrawingContext();

    const title = type === DrawType.Point ? "Punkts" : type === DrawType.Polyline ? "Līnijveida objekts" : "";

    return (
        <div
            className={classNames("draw-button", { active: drawType === type })}
            onClick={() => onDrawStart(type)}
            data-title={title}
        >
            <span className={iconClass}></span>
        </div>
    );
};
